import { render, staticRenderFns } from "./IconServerSolid.vue?vue&type=template&id=55e04169"
import script from "./IconServerSolid.vue?vue&type=script&lang=js"
export * from "./IconServerSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports